import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_contact_submission = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/contact/`,
        method: "GET"
    })
}

export const submit_contact_form = async (formData) => {
    if (!formData) return { error: "No form data provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/contact/`,
        method: "POST",
        body: JSON.stringify(formData)
    })
}

export const update_contact_form_by_id = async (form_id, formData) => {
    if (!form_id) return { error: "No form id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/contact/id/${form_id}`,
        method: "PUT",
        body: JSON.stringify(formData)
    })
}

export const delete_contact_form_by_id = async (form_id) => {
    if (!form_id) return { error: "No form id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/contact/id/${form_id}`,
        method: "DELETE"
    })
}

export const fetch_contact_form_by_id = async (form_id) => {
    if (!form_id) return { error: "No form id provided" }
    return await serverFetch({
        endpoint: `${config.endpoint}/contact/id/${form_id}`,
        method: "GET"
    })
}
